
import { Component, Vue } from 'vue-property-decorator';
import api from '@/api';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { pointCalculator } = api;

@Component({
  components: {
    ItemForm,
  },
})
export default class PointCalculatorCreate extends Vue {
  private loading = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status, message } = await pointCalculator.add(form);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        this.$router.back();
      } else {
        await Swal.fire({ icon: 'warning', title: message });
      }
      this.loading = false;
    }
  }
}
